// ─── Accès aux inventaires et à l'arbre de rangement (section de Profil) ──
// Injectée dans EcranProfil (prop `sections`, `acces:true`). Chaque inventaire
// et l'arbre de rangement partagé reçoivent la MÊME carte unifiée `SectionAcces`
// (modèle 3 niveaux : lecteur / contributeur / gestionnaire). Le miroir `acces`
// (tableau) et `lecteurs` restent écrits pour le gating Firestore existant.
//
// Le module fournit les ressources ; le Core fournit membres + le composant.
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useUI, useT, useEspace, membresDe, SectionAcces } from '@mop/core';
import {
  ecouterInventaires, accesInventaire, definirAccesInventaire, assurerAccesInventaire,
} from './services/inventaires';
import { ecouterPlansEspace, accesPlan, definirAccesPlanN } from './services/plansData';

export default function SectionAccesInventaire() {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const { espaceActif, tenantId, tenantIds, tenantRangement } = useEspace();

  const [inventaires, setInv] = useState([]);
  const [plans, setPlans] = useState([]);   // un PLAN = une ressource (Maison, Garage…)

  const membres  = useMemo(() => membresDe(espaceActif), [espaceActif]);
  const membresUids = useMemo(() => membres.map(m => m.uid), [membres]);
  const ownerUid = espaceActif?.creePar;

  useEffect(() => {
    if (!tenantId) { setInv([]); return undefined; }
    return ecouterInventaires(tenantIds?.length ? tenantIds : tenantId, (l) => {
      setInv(l);
      l.forEach(inv => assurerAccesInventaire(inv, ownerUid, membresUids));
    }, () => {});
  }, [tenantId, (tenantIds || []).join(','), ownerUid, membresUids.join(',')]); // eslint-disable-line react-hooks/exhaustive-deps

  // Les PLANS sont des ressources à part entière (collection `plans`) : un plan
  // = une carte d'accès, comme un inventaire (fin de la carte unique héritée
  // de l'ancien arbre `emplacements/{tenant}`).
  useEffect(() => {
    if (!espaceActif?.id) { setPlans([]); return undefined; }
    return ecouterPlansEspace(espaceActif.id, setPlans, () => {});
  }, [espaceActif?.id]);

  if (!inventaires.length && !plans.length) {
    return <Text style={s.vide}>{t('inventaire.aucunInventaireRegler')}</Text>;
  }

  return (
    <View>
      {inventaires.map(inv => (
        <SectionAcces key={inv.id} titre={inv.nom} emoji={inv.emoji || '📦'}
          acces={accesInventaire(inv)} membres={membres} ownerUid={ownerUid}
          onChange={(acces) =>
            definirAccesInventaire(inv.id, { creePar: inv.creePar, ownerUid, membresUids, acces }).catch(() => {})} />
      ))}
      {plans.map(p => (
        <SectionAcces key={p.id} titre={p.nom || t('inventaire.plan')} emoji={p.emoji || '🗺️'}
          acces={accesPlan(p)} membres={membres} ownerUid={ownerUid}
          onChange={(acces) =>
            definirAccesPlanN(p.id, { creePar: p.creePar, ownerUid, membresUids, acces }).catch(() => {})} />
      ))}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  vide: { fontSize: 12.5, color: UI.muted, paddingVertical: 8 },
});
